import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getInvestorQueryParams, withInvestorQuery } from "../../../utils/investorRouteHelpers";

/** Legacy onboarding verification route — redirects to profile KYC tab. */
export default function InvestorOnboardingVerificationPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const preservedQuery = getInvestorQueryParams(searchParams);

  useEffect(() => {
    navigate(withInvestorQuery("/invest/profile?tab=verification", preservedQuery), { replace: true });
  }, [navigate, preservedQuery]);

  return null;
}
